import { useNavigate } from "react-router-dom";
import { Typography } from "../components/atoms/Typography";
import { CategoryCard } from "../components/molecules/CategoryCard";
import { ArrowLeft, FileText, LayoutTemplate } from "lucide-react";

export const GameRulesTemplatesSelectionPage = () => {
  const navigate = useNavigate();

  return (
    <section className="page-section max-w-7xl mx-auto">
      <button type="button" onClick={() => navigate("/library")} className="back-link">
        <ArrowLeft className="h-4 w-4 shrink-0" aria-hidden />
        Back to Library
      </button>
      <header className="page-header">
        <div>
          <Typography as="h1" variant="h1">
            Game Rule
          </Typography>
          <p className="page-subtitle">Select a category to get started.</p>
        </div>
      </header>
      <div className="grid gap-6 md:grid-cols-2">
        <CategoryCard
          title="Game Rules"
          description="Manage KB clause sections and version history for game rules."
          icon={FileText}
          onClick={() => navigate("/rules")}
        />
        <CategoryCard
          title="Templates"
          description="Create and manage game rule document templates."
          icon={LayoutTemplate}
          onClick={() => navigate("/rules/templates")}
        />
      </div>
    </section>
  );
};
